<template>
  <div class="wrapper">
    <div class="images">
      <div class="content-7">
        <!-- <header-detail :lottery-code="isActive" /> -->
      </div>
      <div class="content-8">
        <div class="content-8__titlebar">
          <div class="content-8__titlebar__left">
            <div class="c8-titlename">
              <span class="c8-titlename__text">{{ cpTypeTitle }}</span>
            </div>
            <div class="c8-menubox">
              <div class="menubar">
                <div class="menubar__itembox">
                  <div
                    v-for="(tab, tabIndex) in tabList"
                    :id="`${tabIndex}-tab-point`"
                    :key="`tabIndex-${tabIndex}`"
                    class="menubar__item"
                    :class="[isActive === tab ? 'active' : '']"
                    @click="switchTab(tab, tabIndex)"
                  >
                    <span class="menubar__item__text">{{
                      cplist[tab] ? cplist[tab].name : ''
                    }}</span>
                    <div class="menubar__item__lightborder"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <transition name="tab" mode="out-in">
          <component
            :is="chooseComponent"
            :key="chooseComponent + '-' + keyNumber"
            :tuku-category="tukuCategory"
            :type="isActive"
            :previous-tab-index="previousTabIndex"
            :current-tab-index="currentTabIndex"
            :cp-type="cpType"
          />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import Hk6Pinyin from '@/components/web/pages/images/Hk6Pinyin'
import ImagesList from '@/components/web/pages/images/ImagesList'
import CanvasImagesList from '@/components/web/pages/images/CanvasImagesList'
import { cpTypeKeys, typeMapTitle } from '@/utils/drawCanvas/common'

export default {
  name: 'CpType',
  components: {
    Hk6Pinyin,
    ImagesList,
    CanvasImagesList
  },
  transition: 'layout',
  provide() {
    return {
      provideCptypeData: () => ({
        cpType: this.cpType
      })
    }
  },
  data() {
    return {
      isActive: '',
      chooseComponent: '',
      keyNumber: null,
      previousTabIndex: null,
      currentTabIndex: null
    }
  },
  computed: {
    // 根據 cpType 返回對應的 tab 列表和詳細資訊
    cpTypeData() {
      const mapping = {
        liuHe: {
          tab: this.$store.state.site.webTukuTab.sixhcTukuTab,
          detail: this.$store.state.lottery.liuHeDetail
        },
        pk10: {
          tab: this.$store.state.site.webTukuTab.pk10TukuTab,
          detail: this.$store.state.lottery.pk10Detail
        },
        ssc: {
          tab: this.$store.state.site.webTukuTab.sscTukuTab,
          detail: this.$store.state.lottery.sscDetail
        }
      }
      return mapping[this.cpType] || { tab: {}, detail: {}}
    },
    // 要生成的tab
    tabList() {
      return this.cpTypeData.tab
    },
    // 每一個tab的詳細內容
    cplist() {
      return this.cpTypeData.detail
    },
    // 從 store 取圖庫ID列表
    tukuCategory() {
      if (this.$store.state.site.tuku.siteSetting.tuku[this.isActive]) {
        return this.$store.state.site.tuku.siteSetting.tuku[this.isActive]
          .categoryIDs
      } else {
        console.warn('[warn]: No id, check tuku.categoryIDs')
        return []
      }
    },
    cpType() {
      return this.$route.params.cpType || 'liuHe'
    },
    cpTypeTitle() {
      return typeMapTitle[this.cpType] || '圖庫'
    },
    // 組件名稱映射表
    componentMapping() {
      return {
        liuHe: { // hk6 與其他 六合彩 組件不同
          hk6: 'Hk6Pinyin',
          default: 'ImagesList'
        },
        ssc: {
          default: 'ImagesList'
        },
        '11x5': {
          default: 'ImagesList'
        }
      }
    }
  },
  watch: {
    keyNumber(newVal, oldVal) {
      this.previousTabIndex = oldVal
      this.currentTabIndex = newVal
    },
    isActive() {
      this.$store.dispatch('lottery/setCanvasNewsURL', '')
    }
  },
  async created() {
    await this.$store.dispatch('lottery/getPublicCp')
    if (this.cpType !== 'pk10') { // pk10 不用 get cpsDetail
      await this.$store.dispatch('lottery/getCpsDetail', { cpCode: this.isActive, cpType: this.cpType })
    }
    const { lotteryCode, action, authorization } = this.$route.query
    this.$sentry.captureMessage(`this.$route.query : ${this.isActive} => created`, {
      level: 'info',
      extra: {
        fullData: JSON.stringify(this.$route.query)
      }
    })
    this.$store.dispatch('lottery/setDrawParams', { // 將網址上的繪圖參數傳給 store
      action,
      authorization
    })
    // 從 lotteryCode 來決定要顯示哪個圖庫元件
    this.selectTab(this.checkLotteryCode(lotteryCode), this.checkLotteryCodeIndex(lotteryCode))
  },
  methods: {
    selectTab(value, indexname) { // 首次進入執行
      this.changeTabComponent(value, indexname)
    },
    switchTab(value, indexname) { // 點擊 tab 執行
      const validCpTypes = cpTypeKeys
      const cpType = validCpTypes.includes(this.cpType) ? this.cpType : 'liuHe'
      this.changeTabComponent(value, indexname)
      window.location.href = `/images/${cpType}?lotteryCode=${value}`
    },
    changeTabComponent(value, indexname) {
      this.isActive = value
      this.keyNumber = indexname

      if (this.cpType === 'pk10') { // pk10 使用 CanvasImagesList 組件
        this.chooseComponent = 'CanvasImagesList'
      } else {
        const typeMap = this.componentMapping[this.cpType]
        if (typeMap) {
          this.chooseComponent = typeMap[value] || typeMap.default // 使用對應的組件或預設值
        } else {
          // 如果 componentMapping 中沒有找到 cpType，則使用預設組件
          this.chooseComponent = 'ImagesList'
        }
      }
      this.changeTabPosition(this.keyNumber)
    },
    changeTabPosition(index) {
      if (!process.client) { return }
      if (index !== undefined && index >= 0) {
        const element = document.getElementById(`${index}-tab-point`)
        if (element) {
          element.scrollIntoView({
            block: 'nearest', inline: 'nearest'
          })
        }
      }
    },
    checkLotteryCode(lotteryCode) {
      const matchingTab = this.tabList.find(tab => tab === lotteryCode)
      return matchingTab ? lotteryCode : (this.tabList[0] || 'hk6')
    },
    checkLotteryCodeIndex(lotteryCode) {
      return this.tabList.includes(lotteryCode) ? this.tabList.indexOf(lotteryCode) : 0
    }
  }
}
</script>

<style lang="scss" scoped>
.content-8__titlebar {
  overflow-x: auto;
  overflow-y: hidden;
  &__left {
    width: 100%;
  }
}
.c8-titlename {
  flex: none;
}
.c8-menubox {
  flex: 1;
  overflow-x: auto;
  overflow-y: hidden;
  width: 100%;
}
.menubar {
  overflow-x: auto;
  overflow-y: hidden;
  &__itembox {
    width: 100%;
  }
}
.c8-select__search {
  flex: none;
}
.justify-between {
  justify-content: space-between;
}
.border-bottom {
  border-bottom: solid 1px #ebebeb;
}
.font-30 {
  font-size: 30px;
}

.content-8__content:nth-child(even) {
  background-color: #fafafa;
}

.six-imgbox {
  display: flex;
  flex-direction: column;
  width: 100%;
  &__title {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    box-sizing: border-box;
    border-bottom: solid 1px #ebebeb;

    &__right {
      height: 100%;
      display: flex;
      align-items: center;
      &__text {
        margin: 0 8px;
      }
    }
  }
  &__control {
    min-height: 50px;
    width: 100%;
    padding: 0 16px;
    box-sizing: border-box;
    border-bottom: solid 1px #ebebeb;
    position: relative;
    &__icon {
      position: absolute;
      width: 16px;
      height: 16px;
      right: 16px;
      top: 16px;
      cursor: pointer;
      > img {
        width: 100%;
      }
    }
  }
  &__content {
    padding: 16px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    position: relative;
    .content-1__films {
      border: 0;
    }
    .six-imgbox__img {
      width: 100%;
      text-align: center;
      > img {
        max-width: 100%;
      }
    }
  }
}
</style>
